import authBaseHttpRequest from './authBaseHttpRequest';

export const getAllInvoices = ({ params }) => {
  return authBaseHttpRequest({
    method: 'post',
    url: `/billing/fetch-bill/?agency=${params.agency}`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const downloadReport = ({ id, agency }) => {
  return authBaseHttpRequest({
    method: 'get',
    url: `/billing/download/monthly-bill/?_id=${id}&agency=${agency}`,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/pdf',
    },
  })
    .then((response) => {
      return { response: response.data, headers: response.headers };
    })
    .catch((error) => ({ error: error.response }));
};

export const downloadInvoice = ({ id, agency }) => {
  return authBaseHttpRequest({
    method: 'get',
    url: `/billing/download/monthly-invoice/?_id=${id}&agency=${agency}`,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/pdf',
    },
  })
    .then((response) => {
      return { response: response.data, headers: response.headers };
    })
    .catch((error) => ({ error: error.response }));
};

export const makeMonthlyPayment = ({ params }) => {
  return authBaseHttpRequest({
    method: 'post',
    url: `/billing/checkout/?agency=${params.agency}`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const fetchAllPaymentTransactions = ({ params }) => {
  return authBaseHttpRequest({
    method: 'post',
    url: `/reward/payment-transactions/`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const addFundsToBank = ({ params }) => {
  return authBaseHttpRequest({
    method: 'post',
    url: `/reward/payment-checkout/`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};
